import React from "react";
// styles
import injectSheet from 'react-jss';
import styles from './companyinfo_styles';

const Field = injectSheet(styles)((props) => {
  const {
    title,
    content,
  } = props

  return (
    <div className={props.classes.field}>
      <h4 className="titleMargin">{title}</h4>
      {content}
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Field;